import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  hover?: boolean;
}
export function Card({
  children,
  className = '',
  onClick,
  hover = false
}: CardProps) {
  return <div className={`
        bg-white rounded-xl shadow-sm border border-gray-100 p-6
        ${hover || onClick ? 'transition-all duration-200 hover:shadow-md hover:-translate-y-1 cursor-pointer' : ''}
        ${className}
      `} onClick={onClick} data-id="element-366">
      {children}
    </div>;
}